<template>
  <div class="footer">
    技能补给君 版权所有&nbsp;&nbsp;<a href="http://www.qjlong01.top" target="_blank">http://www.qjlong01.top</a>
  </div>
</template>

<script>

</script>

<style lang="scss" scoped>
.footer{
  padding: 20px;
  display: flex;
  align-items: center;
}
</style>